<template>
  <div>
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/discountCoupon' }">优惠券管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加优惠券</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div class="coupon">
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
          <div class="coupon-title">基本信息</div>

          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="优惠券名称" prop="name">
                <el-input
                  size="small"
                  v-model="addForm.name"
                  placeholder="请输入优惠券名称"
                  auto-complete="off"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="使用时间" prop="time">
                <el-date-picker
                  size="small"
                  v-model="addForm.times"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="timeChange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                ></el-date-picker>
                <span style="color: #A2AABC;margin-left:10px">最长可提前60天创建，有效期不能超过6个月</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="商品范围" prop="type">
                <div class="flex-starts">
                  <el-button
                    type="primary"
                    :disabled="radioDis"
                    size="small"
                    @click="openaddFormVisible()"
                  >添加商品</el-button>
                  <el-radio-group style="margin-left:10px" v-model="addForm.type">
                    <el-radio :label="item" v-for="(item,index) in typeList" :key="index">{{item}}</el-radio>
                  </el-radio-group>
                </div>
                <el-table
                  ref="multipleTables"
                  v-if="checkList.length>0"
                  :data="checkList"
                  tooltip-effect="dark"
                  style="width: 100%;margin-top:16px"
                  highlight-current-row
                  border
                >
                  <el-table-column prop="name" show-overflow-tooltip label="商品">
                    <template slot-scope="row">
                      <el-row>
                        <el-col :span="8">
                          <span>
                            <img
                              style="margin-right:10px;"
                              width="100%"
                              height="44px"
                              :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                            />
                          </span>
                        </el-col>
                        <el-col :span="16">
                          <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                          <span style="display:block;margin-left:10px;">
                            <span style="color:red">￥{{row.row.price}}</span>
                            <span
                              style="text-decoration:line-through;color:rgb(162,170,188)"
                            >￥{{row.row.originalPrice}}</span>
                          </span>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                    <template slot-scope="row">
                      <span style="display:block;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span
                          style="text-decoration:line-through;color:rgb(162,170,188)"
                        >￥{{row.row.originalPrice}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                    <template slot-scope="row">{{row.row.validDay?row.row.validDay+'天':'不限'}}</template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="subjectCourseName"
                    label="所属科目"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    width="80"
                    prop="remark"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="deleteSArr(scope.$index)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="是否上架" prop="state">
                <el-radio-group style="margin-left:10px" v-model="addForm.state">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="-1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <div class="coupon-title">面额信息</div>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="优惠券金额" prop="discountPrice">
                <div class="flex-starts">
                  <el-input
                    size="small"
                    type="number"
                    min="0"
                    v-model="addForm.discountPrice"
                    placeholder="请输入优惠券金额"
                    auto-complete="off"
                    maxlength="20"
                  >
                    <template slot="append">元</template>
                  </el-input>
                  <span style="color: #A2AABC;margin-left:10px">优惠金额必须是5的倍数</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="使用门槛" prop="limitPrice">
                <div class="flex-starts">
                  <el-input
                    type="number"
                    min="0"
                    size="small"
                    v-model="addForm.limitPrice"
                    placeholder="门槛需高于优惠金额"
                    auto-complete="off"
                    maxlength="20"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="发行量" prop="quantity">
                <div class="flex-starts">
                  <el-input
                    type="number"
                    min="0"
                    size="small"
                    v-model="addForm.quantity"
                    placeholder="需大于等于500，不超过10万"
                    auto-complete="off"
                    maxlength="20"
                  >
                    <template slot="append">张</template>
                  </el-input>
                  <span style="color: #A2AABC;margin-left:10px">优惠券创建后，发行量只能增加不能减少，请谨慎设置</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="每人限领" prop="limitQuantity">
                <div class="flex-starts">
                  <el-input
                    size="small"
                    type="number"
                    min="0"
                    v-model="addForm.limitQuantity"
                    placeholder="请输入每人限领"
                    auto-complete="off"
                    maxlength="20"
                  >
                    <template slot="append">张</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <div class="coupon-title">效果图</div>
          <div class="designSketch">
            <div class="left">
              <div>
                <span style="font-size: 13px;">￥</span>
                <span style="font-size: 30px;">{{addForm.discountPrice}}</span>
              </div>
              <div>
                <span style="font-size: 13px;">满{{addForm.limitPrice}}可用</span>
              </div>
            </div>
            <div class="right">
              <div class="right-top">
                <div>
                  <div class="text" style="color:#333">{{addForm.name}}优惠券</div>
                  <div class="text">使用范围：{{addForm.type}}</div>
                </div>
                <div>
                  <el-button size="small" type="primary" round>立即领取</el-button>
                </div>
              </div>
              <div class="right-bottom text">{{addForm.startTime}}-{{addForm.endTime}}</div>
            </div>
          </div>
        </el-form>
        <div style="margin-top:20px;">
          <el-button size="small">重置</el-button>
          <el-button size="small" @click="addCoupon()" type="primary">提交</el-button>
        </div>
      </div>
    </el-card>
    <el-dialog title="添加商品" v-loading="loading1" :visible.sync="addFormVisible" width="60%" left>
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="9" :md="9" :lg="9">
            <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left:10px">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              ref="multipleTables"
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%;"
              highlight-current-row
              @selection-change="selectionChange"
              border
            >
              <el-table-column type="selection" min-width="40"></el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right:10px;"
                          width="100%"
                          height="44px"
                          :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      <span style="display:block;margin-left:10px;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span
                          style="text-decoration:line-through;color:rgb(162,170,188)"
                        >￥{{row.row.originalPrice}}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                <template slot-scope="row">
                  <span style="display:block;">
                    <span style="color:red">￥{{row.row.price}}</span>
                    <span
                      style="text-decoration:line-through;color:rgb(162,170,188)"
                    >￥{{row.row.originalPrice}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                <template slot-scope="row">{{row.row.validDay?row.row.validDay+'天':'不限'}}</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px;text-align: right;"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formLabelWidth: "100px",
      addFormVisible: false,
      loading1: false,
      radioDis: true,
      radio: 3,
      addForm: {
        name: "",
        type: "",
        typeIds: "",
        name: "",
        times: [],
        state: 1,
        useQuantity: null,
        getQuantity: null,
        limitQuantity: null,
        quantity: null,
        limitPrice: null,
        discountPrice: null,
        endTime: "",
        startTime: ""
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: "blur"
          }
        ],
        quantity: [
          {
            required: true,
            message: "请输入发行量",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请输入商品范围",
            trigger: "blur"
          }
        ],
        limitQuantity: [
          {
            required: true,
            message: "请输入每人限领",
            trigger: "blur"
          }
        ],
        limitPrice: [
          {
            required: true,
            message: "请输入使用门槛",
            trigger: "blur"
          }
        ],
        discountPrice: [
          {
            required: true,
            message: "请输入优惠券金额",
            trigger: "blur"
          }
        ],
        times: [
          {
            required: true,
            message: "请输入使用时间",
            trigger: "blur"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          var times = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < times;
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchForm: {
        sell: 1,
        name: "",
        courseIds: []
      },
      times: [],
      tableList: [],
      typeList: [],
      subjectTreeList: [],
      arrsSelect: [],
      tableList: [],
      checkList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children"
      },

      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      }
    };
  },
  created() {},
  methods: {
    timeChange(val) {
      console.log(val);
      this.addForm.times = val;
      if (val.length == 2) {
        this.addForm.startTime = val[0];
        this.addForm.endTime = val[1];
      } else {
        this.addForm.startTime = "";
        this.addForm.endTime = "";
      }
    },
    closeDialog() {
      typeIds;
      this.addFormVisible = false;
      let typeIds = [];
      this.checkList.forEach((item, index) => {
        typeIds.push(item.id);
      });
      this.addForm.typeIds = typeIds.join(",");
      console.log("this.addForm.typeIds", this.addForm.typeIds);
    },
    selectionChange(val) {
      this.checkList = val;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    getList() {
      this.loading1 = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then(result => {
          this.loading1 = false;
          this.arrsSelect = [];

          this.tableList = result.data.records;
          this.page.total = result.data.total;
        })
        .then(res => {
          let that = this;
          if (this.addFormVisible) {
            that.$nextTick(function() {
              if (this.addForm.typeIds) {
                let arr = this.addForm.typeIds.split(",");
                arr.forEach(item => {
                  let sty = true;
                  let indexs = null;
                  this.tableList.forEach((items, index) => {
                    if (item == items.id) {
                      sty = false;
                      indexs = index;
                    }
                  });
                  if (!sty) {
                    that.$refs.multipleTables.toggleRowSelection(
                      this.tableList[indexs],
                      true
                    );
                  }
                });
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openaddFormVisible() {
      this.addFormVisible = true;
      this.getList();
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })

        .catch(error => {
          console.log(error);
        });
    },
    subjectChange(val) {
      this.searchForm.courseIds = [];
      val.forEach(item => {
        this.searchForm.courseIds.push(item[2]);
      });
    },
    deleteSArr(index) {
      this.checkList.splice(index, 1);
    },
    addCoupon() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (
            Number(this.addForm.discountPrice) > Number(this.addForm.limitPrice)
          ) {
            return this.$message.error("优惠券金额要小于使用门槛");
          }
          if (this.addForm.discountPrice % 5 != 0) {
            return this.$message.error("优惠金额必须是5的倍数");
          }
          this.api.discountCoupon
            .addDiscountCoupon(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.$router.go(-1);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
        }
      });
    },
    getDiscountCouponTypeList() {
      this.api.discountCoupon
        .getDiscountCouponTypeList()
        .then(result => {
          if (result.success) {
            this.typeList = result.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    "addForm.limitPrice": function() {
      if (this.addForm.discountPrice)
        if (
          Number(this.addForm.discountPrice) > Number(this.addForm.limitPrice)
        ) {
          this.$message.error("优惠券金额要小于使用门槛");
        } else {
        }
    },
    "addForm.discountPrice": function() {
      if (this.addForm.discountPrice % 5 != 0) {
        this.$message.error("优惠金额必须是5的倍数");
      } else {
      }
      if (this.addForm.limitPrice)
        if (
          Number(this.addForm.discountPrice) > Number(this.addForm.limitPrice)
        ) {
          this.$message.error("优惠券金额要小于使用门槛");
        } else {
        }
    },
    "addForm.type": function() {
      if (this.addForm.type == "指定商品") {
        this.radioDis = false;
      } else {
        this.radioDis = true;
        this.checkList = [];
      }
    }
  },
  computed: {
    ...mapGetters(["loginData"])
  },
  mounted() {
    this.getDiscountCouponTypeList();
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.coupon {
  .designSketch {
    width: 400px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    .right {
      height: 66px;
      width: 280px;

      display: flex;
      flex-direction: column;
      //   align-content: space-between;
      justify-content: space-between;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      .text {
        font-size: 13px;
        color: #a2aabc;
        margin-bottom: 4px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-bottom {
        margin-bottom: 4px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 66px;
      height: 66px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #409eff;
      }
    }
  }
  .line {
    border: solid 1px rgba(238, 238, 238, 1);
    margin-bottom: 20px;
  }
  .coupon-title {
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    color: #455a64;
    line-height: 16px;
    margin-bottom: 15px;
  }
  .el-input,
  .el-input__inner {
    width: 400px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/discountCoupon/addCoupon.vue